const rowSizingCls = "c2lr1smpdh9";
const rowOverridesCls = "c2lr112m8fw";
const mobileContentWrapperCls = "c2lmb5orqu";
const mobileHeadingCls = "c2lmwak6z1";
const mobileMetaCls = "c2lm5xj71k";
const mobileDateCls = "c2lms9w1e7";

export { mobileContentWrapperCls, mobileDateCls, mobileHeadingCls, mobileMetaCls, rowOverridesCls, rowSizingCls };
import "./_course-item.style.linaria.module.css";
//# sourceMappingURL=_course-item.style.js.map
